import { useParams } from 'react-router-dom';
import AddGrid from './AddGrid';

const GridReview = () => {
  const { gridId } = useParams();

  return <AddGrid reviewMode reviewGridId={gridId} />;
};

export default GridReview;
